import { Dispatch, ThunkAction } from 'app/types/actions';
import { IGetState } from 'app/types/types';
import { columnWidthSetAction } from '../../../../../asidePanel/store/actions/columnWidthSetAction';
import { ASIDE_COLUMN_MIN_WIDTH, ASIDE_MAX_WIDTH, GOOGLE_SPACING } from '../../../../../../../../const';
import { CLASS_ASIDE_PANEL } from '../../../../../asidePanel/constants';
import {
    ASIDE_PANE_COMMENTS_COLUMN_ANIMATION
} from '../../../../../asidePanel/components/AsidePanelCommentsColumnViewButton/constants';
import { CLASS_ASIDE_PANEL_BODY } from '../../../../../asidePanel/components/AsidePanelBody/constants';
import { CLASS_CARD_DETAILS } from '../../../../constants';
import { CLASS_ASIDE_PANEL_ACTIONS } from '../../../../../asidePanel/components/AsidePanelActions/constants';
import {
    authUserSetCommentsColumnView
} from '../../../../../../../../rest/effects/authUser/authUserSetCommentsColumnView';
import { vent } from '../../../../../../../../store/constants';
import { getAsidePanel } from '../../../../../asidePanel/store/selectors/getAsidePanel';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import {
    SegmentCardOptionStatusValue,
    SegmentCardSourceValue
} from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onTurnOffCommentsColumn = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(columnWidthSetAction(ASIDE_COLUMN_MIN_WIDTH));
        const asidePanel = document.querySelector('.' + CLASS_ASIDE_PANEL) as HTMLElement;
        if (!asidePanel) return;
        const transition = `all ${ASIDE_PANE_COMMENTS_COLUMN_ANIMATION}ms cubic-bezier(.23,1,.32,1)`;
        asidePanel.style.transition = transition;
        const asideBody = document.querySelector(`.${CLASS_ASIDE_PANEL_BODY}`) as HTMLElement;
        const body = document.querySelector(`.${CLASS_CARD_DETAILS}__body`) as HTMLElement;
        const details = document.querySelector(`.${CLASS_CARD_DETAILS}__container`) as HTMLElement;
        const column = document.querySelector(`.${CLASS_CARD_DETAILS}__container-wrapper`) as HTMLElement;
        body.style.transition = transition;
        if (!details || !column) return;

        dispatch(segmentTrackAction(SegmentCardEvent.COLUMN_TOGGLE, {
            name: SegmentCardOptions.STATUS,
            value: SegmentCardOptionStatusValue.OFF,
        }, [
            {
                name: SegmentCardOptions.SOURCE,
                value: SegmentCardSourceValue.RESIZE,
            }
        ]));

        details.style.overflow = 'hidden';
        column.style.padding = '0';
        const isScrollVisible = document.documentElement.classList.contains('scroll-visible');
        const isMinimized = body.className.includes('--actions-minimized');
        const offset = GOOGLE_SPACING * (isMinimized ? 1.5 : 2.5);
        body.style.minWidth = `${body.offsetWidth - (isScrollVisible ? offset : 0)}px`; // scroll
        const columnWidth = getAsidePanel(getState()).columnWidth || ASIDE_COLUMN_MIN_WIDTH;
        asidePanel.style.width = `${asidePanel.offsetWidth - columnWidth + (isScrollVisible ? 0 : offset)}px`; // scroll
        asideBody.classList.remove(CLASS_ASIDE_PANEL_BODY + '--columns');
        dispatch(authUserSetCommentsColumnView(false));
        setTimeout(() => {
            column.style.opacity = '0';
            requestAnimationFrame(() => {
                vent.trigger(vent['view:resized']); // to setPanelsWidth
                setTimeout(() => {
                    asidePanel.style.transition = 'unset';
                    details.style.overflow = 'auto';
                }, 0);
            });
        }, ASIDE_PANE_COMMENTS_COLUMN_ANIMATION);
    };
    return action;
};
